import apiClient, { baseURL, handleResponse } from "./axios";
import { Routes } from "../routes";
import { history } from "..";

export const login = async (payload) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": 'application/json',
    },
    body: JSON.stringify(payload)
  };
  return fetch(`${baseURL}admin/auth/login`, requestOptions).then(handleResponse);
}

export const logout = () => {
  localStorage.removeItem("user_data")
  history.push(Routes.Signin)
}

// admin
export const fetchAdmin = async (payload) => {
  console.log(payload)
  try {
    const data = JSON.parse(localStorage.getItem('user_data'))
    const url = payload.method === "PUT" ? `${baseURL}admin/admin/${payload.data.user_id}` : `${baseURL}admin/admin`
    const requestOptions = {
      method: payload.method,
      headers: {
        "Content-Type": 'application/json',
        "Authorization": "Bearer " + data.token || undefined
      },
      body: JSON.stringify(payload.data)
    };
    return fetch(url, requestOptions).then(handleResponse);
  } catch (error) {
    console.log(error)
  }

}

export async function imgGal() {
  return apiClient
    .get('/admin/image/gallery')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createImgGal(payload) {
  return apiClient
    .post('/admin/image/gallery', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateImgGal(payload) {
  return apiClient
    .put(`/admin/image/gallery/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteImgGal(id) {
  return apiClient
    .delete(`/admin/image/gallery/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function faqs() {
  return apiClient
    .get('/admin/faq')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createFaq(payload) {
  return apiClient
    .post('/admin/faq', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteFaq(id) {
  return apiClient
    .delete(`/admin/faq/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateFaq(payload) {
  return apiClient
    .put(`/admin/faq/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function policy() {
  return apiClient
    .get('/admin/term_policy/policy')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function termConditions() {
  return apiClient
    .get('/admin/term_policy/terms')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createTerms(payload) {
  const url = '/admin/term_policy'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateTerms(payload) {
  console.log(payload)
  const url = `/admin/term_policy/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deleteTerms(id) {
  return apiClient
    .delete(`/admin/term_policy/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// how it works
export async function howItWorks() {
  return apiClient
    .get('/admin/how_it_works')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createHowItWork(payload) {
  return apiClient
    .post('/admin/how_it_works', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteHowItWork(id) {
  return apiClient
    .delete(`/admin/how_it_works/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateHowItWork(payload) {
  return apiClient
    .put(`/admin/how_it_works/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
// blogs
export async function blogItems(payload) {
  return apiClient
    .get(`/admin/blogs/list/${payload}`)
    .then(response => {
      if (response) {
        console.log(response)
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
// blogs
export async function blogs() {
  return apiClient
    .get('/admin/blogs')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createBlogs(payload) {
  return apiClient
    .post('/admin/blogs', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateBlogTop(payload) {
  return apiClient
    .post('/admin/blogs/top', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateBlogs(payload) {
  return apiClient
    .put(`/admin/blogs/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteBlog(id) {
  return apiClient
    .delete(`/admin/blogs/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function activateBlog(payload) {
  console.log(payload)
  const url = `/admin/blogs/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createBlogList(payload) {
  return apiClient
    .post('/admin/blogs/list', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function generateAIArticle(data) {
  return apiClient
    .post('/admin/ai/generate-article', data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateBlogList(payload) {
  return apiClient
    .put(`/admin/blogs/list/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteBlogList(id) {
  return apiClient
    .delete(`/admin/blogs/list/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function activateBlogList(payload) {
  console.log(payload)
  const url = `/admin/blogs/list/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// settings update
export async function updateSettings(payload) {
  console.log(payload)
  return apiClient
    .put(`/admin/settings/${payload.type}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateLogo(payload) {
  console.log(payload)
  return apiClient
    .put(`/admin/settings/${payload.type}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateHowItWorkVideo(payload) {
  console.log(payload)
  return apiClient
    .put(`/admin/settings/how_it_works/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createHowItWorkVideo(payload) {
  console.log(payload)
  return apiClient
    .put(`/admin/settings/how_it_works`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getSettings() {
  return apiClient
    .get(`/admin/settings`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// abouts
export async function getAbouts() {
  return apiClient
    .get(`/admin/about/contents`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getCareer() {
  return apiClient
    .get(`/admin/career`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getCareerTop() {
  return apiClient
    .get(`/admin/career/top`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createCareer(payload) {
  console.log(payload)
  return apiClient
    .post(`/admin/career`, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createCareerOthers(payload) {
  console.log(payload)
  return apiClient
    .post(`/admin/career/others`, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateCareer(payload) {
  return apiClient
    .put(`/admin/career/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteCareer(id) {
  return apiClient
    .delete(`/admin/career/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createAbout(payload) {
  return apiClient
    .post(`/admin/about/contents`, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateAbout(payload) {
  return apiClient
    .put(`/admin/about/contents/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteAbout(id) {
  return apiClient
    .delete(`/admin/about/contents/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// Contact
export async function contacts() {
  return apiClient
    .get('/admin/contacts')
    .then(response => {
      console.log(response)
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createContact(payload) {
  return apiClient
    .post('/admin/contacts', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateContact(payload) {
  const url = payload.type === "update" ? `/admin/contacts/${payload.id}` : `/admin/contacts/${payload.id}/${payload.type}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteContact(id) {
  return apiClient
    .delete(`/admin/contacts/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getSubScribers() {
  const url = `/admin/subscribers`
  return apiClient
    .get(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getMessages() {
  const url = `/admin/messages`
  return apiClient
    .get(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// social links
export async function getSocialLinks() {
  const url = `/admin/social`
  return apiClient
    .get(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateSocial(payload) {
  const url = `/admin/social`
  return apiClient
    .put(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// features
export async function createFeature(payload) {
  const url = `/admin/features`
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateFeature(payload) {
  const url = payload.type === "update" ? `/admin/features/${payload.id}` : `/admin/features/${payload.id}/${payload.type}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getFeature() {
  const url = `/admin/features`
  return apiClient
    .get(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// business
export async function getBusiness(payload) {
  const url = `/admin/business/${payload}`
  return apiClient
    .get(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateBusiness(payload) {
  const url = payload.url
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createBusiness(payload) {
  const url = payload.url
  return apiClient
    .post(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteBusiness(url) {
  return apiClient
    .delete(url)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// products
export async function getProducts() {
  return apiClient
    .get('/admin/products')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getBrands() {
  return apiClient
    .get('/admin/brands')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createProduct(payload) {
  return apiClient
    .post('/admin/products', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateProduct(payload) {
  return apiClient
    .put(`/admin/products/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteProduct(id) {
  return apiClient
    .delete(`/admin/products/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// categories
export async function getCategories() {
  return apiClient
    .get('/admin/products/categories')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function createCategories(payload) {
  return apiClient
    .post('/admin/products/categories', payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function updateCategories(payload) {
  return apiClient
    .put(`/admin/products/categories/${payload.id}`, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function deleteCategories(id) {
  return apiClient
    .delete(`/admin/products/categories/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// home
export async function getHomePage() {
  return apiClient
    .get('/admin/home_page')
    .then(response => {
      if (response) {
        console.log(response)
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createHomeFeature(payload) {
  const url = '/admin/home_page'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateHomeFeature(payload) {
  const url = `/admin/home_page/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function activateHomeFeature(payload) {
  const url = `/admin/home_page/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deleteHome(id) {
  return apiClient
    .delete(`/admin/home_page/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

// Waya-Bank
export async function getBankPage() {
  return apiClient
    .get('/admin/waya_bank')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createBankFeature(payload) {
  const url = '/admin/waya_bank'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateBankFeature(payload) {
  const url = `/admin/waya_bank/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function activateBankFeature(payload) {
  const url = `/admin/waya_bank/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deleteBank(id) {
  return apiClient
    .delete(`/admin/waya_bank/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createListItems(payload) {
  const url = '/admin/waya_bank/list'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateListItems(payload) {
  const url = `/admin/waya_bank/list/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateListItem(payload) {
  const url = `/admin/waya_bank/list/${payload.id}`
  return apiClient
    .put(url, payload.fd)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function activateListItems(payload) {
  const url = `/admin/waya_bank/deactivate/list/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deleteListItems(id) {
  return apiClient
    .delete(`/admin/waya_bank/list/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updateHomePage(payload) {
  // `/admin/products/categories/${payload.type}`
  const url = payload.url
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
// Waya-Bank
export async function getPayPage() {
  return apiClient
    .get('/admin/waya_pay')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function getGramPage() {
  return apiClient
    .get('/admin/waya_gram')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createPayFeature(payload) {
  const url = '/admin/waya_pay'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updatePayFeature(payload) {
  console.log(payload)
  const url = `/admin/waya_pay/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function activatePayFeature(payload) {
  const url = `/admin/waya_pay/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deletePay(id) {
  return apiClient
    .delete(`/admin/waya_pay/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function getPosPage() {
  return apiClient
    .get('/admin/waya_pos')
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function createPos(payload) {
  const url = '/admin/waya_pos'
  return apiClient
    .post(url, payload)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function updatePos(payload) {
  console.log(payload)
  const url = `/admin/waya_pos/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function activatePos(payload) {
  const url = `/admin/waya_pos/deactivate/${payload.id}`
  return apiClient
    .put(url, payload.data)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
export async function deletePos(id) {
  return apiClient
    .delete(`/admin/waya_pos/${id}`)
    .then(response => {
      if (response) {
        const { data, status } = response
        if (status) {
          return data
        }
      }
      return false
    })
    .catch(err => console.log(err))
}
